module.exports = __webpack_public_path__ + "img/pc_download_btn.e2b64dcd.png";